import { Inject, Injectable } from "@angular/core";
import { LOCATION } from "@tylertech/shared-module";

@Injectable()
export class RouteInfoService
{
    private readonly _appName: string;
    private _path: string;
    private readonly _tenant: string;

    constructor(
        @Inject(LOCATION) private readonly location: Location
    )
    {
        this.setPath();
        const [tenant, _appsDir, appName] = this.path.split("/");
        this._tenant = tenant.replace(/[^a-zA-Z0-9_-]/g, "");
        this._appName = appName.replace(/[^a-zA-Z0-9_-]/g, "");
    }

    get path(): string { return this._path; }
    get tenant(): string { return this._tenant; }
    get appName(): string { return this._appName; }

    get baseUrl(): string
    {
        return `/${this.tenant}/apps/${this.appName}`;
    }

    get domain(): string
    {
        return this.location.origin;
    }

    setPath(): void
    {
        this._path = this.location.pathname
            ? this.location.pathname.replace(/^\/+/, '')
            : this.location.pathname;
    }
}
